import { TableData } from '@cokitchen/cokitchen-components';
import StatusColor from 'components/status-badge';
import { ExternalRiderType } from 'models/external-rider.model';
import moment from 'moment';
import React from 'react';
import { ENUM_RIDER_STATUS } from 'utils/enum';
import { getUserName } from 'utils/functions';

type Props = {
  rider: ExternalRiderType;
  status: ENUM_RIDER_STATUS;
};

const ExternalRiderTableData = ({ rider, status }: Props) => {
  return (
    <>
      <TableData>
        <span>{getUserName(rider)}</span>
      </TableData>

      <TableData>
        <span>{rider.email_address}</span>
      </TableData>
      <TableData>
        <span>{rider.date_added ? moment(rider.date_added).format('DD/MM/YYYY') : 'N/A'}</span>
      </TableData>
      <TableData>
        <span>{rider.phone_number}</span>
      </TableData>

      {status !== ENUM_RIDER_STATUS.AWAITING_APPROVAL ? (
        <TableData>
          {status === ENUM_RIDER_STATUS.ALL ? (
            <StatusColor status={rider.status} />
          ) : status !== ENUM_RIDER_STATUS.SCHEDULED ? (
            rider.approval_or_rejected_date ? (
              moment(rider.approval_or_rejected_date).format('DD/MM/YYYY')
            ) : (
              'N/A'
            )
          ) : (
            <></>
          )}
        </TableData>
      ) : (
        <></>
      )}
    </>
  );
};

export default ExternalRiderTableData;
